import { useEffect, useRef } from "react";
import { useLocation } from "react-router";

export const useOnPageExit = (isPageRoute: (pathname: string) => boolean, callback: VoidFunction) => {
  const location = useLocation();
  const prevLocationRef = useRef(location.pathname);

  useEffect(() => {
    const prevPath = prevLocationRef.current;
    const currentPath = location.pathname;

    if (isPageRoute(prevPath) && !isPageRoute(currentPath)) {
      callback();
    }

    prevLocationRef.current = currentPath;
  }, [location.pathname]);
};
